import services from 'service/axios';
import { handleResponse } from 'utils/responseTransformer';
import { getAuthRefreshToken } from 'core/storage/authSessionStorage';

const getAppRefreshToken = async () => {
  const refresh_token = getAuthRefreshToken();

  const query = `grant_type=refresh_token&client_id=client-web-sura&refresh_token=${refresh_token}`;

  try {
    const res = await services.auth_refresh_token('', {
      method: 'POST',
      data: query,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const { data, status } = res;
    return handleResponse(data, status, true);
  } catch (error: any) {
    return handleResponse(
      null,
      error?.response?.status,
      false,
      error,
      null,
      'No se pudo generar el token',
    );
  }
};

export default getAppRefreshToken;
